var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScribbleHorizontalRule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 196.25 22.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#00c68e;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;stroke-dasharray:50 3 100 3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.75,10.49C4.73,1.65,17.67,2,26.4,6.17s17,11,26.64,10.72C67.48,16.4,78.13.12,92.57.77c7.36.33,13.66,5.06,20,8.85a90.16,90.16,0,0,0,83,4.29"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScribbleHorizontalRule);
export default __webpack_public_path__ + "static/media/scribble-horizontal-rule.3d1f79cead0da695a3b7ce3778652d5b.svg";
export { ForwardRef as ReactComponent };